var OSS = require('ali-oss');

let client = new OSS({
  region: 'oss-cn-shenzhen',
  // accessKeyId: 'LTAI4FgEHC8iJab7B6YFTgrF',//旧
  // accessKeySecret: 'LxvC9yNGRWVq1l9Tcq1nun0yLp3gK4', // 旧
  accessKeyId: 'LTAI5tPu8jJMiMybUXUSpMvp',
  accessKeySecret: 'GchIFvJQfMngvzb71mTh2HboOUrqIJ',
  bucket: 'yingedu-video4'
});

let filedir = "newkhy/pro";

const ossClient = {
  // 获取下载
  getFileUrl:async function(fileUrl){
    var url = await client.signatureUrl(fileUrl,{expires:1*60*60*24*365*30});
    return url;
  },
  // 上传
  uploadFile:async function(fileUrl,file,progressFun){
    var fileUrl = filedir + fileUrl;
    await client.multipartUpload(fileUrl, file, { progress: progressFun })
    return fileUrl;
  }
};
export default ossClient;
